/** Asks before deleting a custom metric or view, as AgencyAnalytics does. */

import type { ReactNode } from 'react';

export function ConfirmDelete(props: {
  name: string;
  note: string;
  onCancel: () => void;
  onConfirm: () => void;
}): ReactNode {
  return (
    <div className="rc-scrim">
      <div className="rc kp-small" role="alertdialog" aria-modal="true" aria-labelledby="cd-title">
        <h2 id="cd-title">Delete {props.name}?</h2>
        <p>{props.note}</p>
        <div className="kp-dialog-actions">
          <button type="button" className="btn secondary" onClick={props.onCancel} autoFocus>
            Cancel
          </button>
          <button type="button" className="btn danger" onClick={props.onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
